"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacetByField = void 0;
const _enums_1 = require("../../types/@enums");
const mapFacetEntries_1 = require("../mapFacetEntries");
/**
 * @Function
 * @data the "facets" payload from useFacets hook
 * @type 'CATEGORY' | 'BRAND'
 */
const getFacetByField = (data, field) => {
    let fields = [];
    switch (field) {
        case _enums_1.FacetFieldEnum.CATEGORY:
            fields = ['departments.name', 'departamento-categoria'];
            break;
        case _enums_1.FacetFieldEnum.BRAND:
            fields = ['brand.name', 'marca'];
            break;
    }
    const facets = data.find((facet) => fields.includes(facet.field));
    return facets ? (0, mapFacetEntries_1.mapSubEntriesRecursively)(facets.entries) : [];
};
exports.getFacetByField = getFacetByField;
